import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import JobDetail from './pages/JobDetail';
import Resumes from './pages/Resumes';
import ResumeDetail from './pages/ResumeDetail';
import ResumeCreate from './components/resumes/ResumeCreate';
import Profile from './pages/Profile';
import ProfileEdit from './pages/ProfileEdit';
import { ProtectedRoute } from './utils/ProtectedRoute';
import Jobs from './pages/Jobs';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/jobs" element={<ProtectedRoute><Jobs /></ProtectedRoute>} />
      <Route path="/jobs/:id" element={<ProtectedRoute><JobDetail /></ProtectedRoute>} />
      <Route path="/resumes" element={<ProtectedRoute><Resumes /></ProtectedRoute>} />
      <Route path="/resumes/create" element={<ProtectedRoute><ResumeCreate /></ProtectedRoute>} />
      <Route path="/resumes/:id" element={<ProtectedRoute><ResumeDetail /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/profile/edit" element={<ProtectedRoute><ProfileEdit /></ProtectedRoute>} />
    </Routes>
  );
};

export default AppRoutes; 